import script from "./LegalFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./LegalFormView.vue?vue&type=script&setup=true&lang=js"

import "./LegalFormView.vue?vue&type=style&index=0&id=3825c498&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3825c498"]])

export default __exports__